import React from 'react';

function Brand() {
  return <></>;
}

export default Brand;
